import { render, staticRenderFns } from "./robHouse.vue?vue&type=template&id=1a5d9de5&"
import script from "./robHouse.vue?vue&type=script&lang=js&"
export * from "./robHouse.vue?vue&type=script&lang=js&"
import style0 from "./robHouse.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports